/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Action_Print_QrInputs */

const vi_tea_purchase_action_print_qr = /** @type {(inputs: Tea_Purchase_Action_Print_QrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In tem QR`)
};

/**

* @param {Tea_Purchase_Action_Print_QrInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_action_print_qr = /** @type {((inputs?: Tea_Purchase_Action_Print_QrInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Action_Print_QrInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_action_print_qr(inputs)
});